module.exports = __webpack_public_path__ + "static/media/noun_menu_500623_333333.9169a923.svg";